export const tempColorSetup = {
  "0831":{mainColor:"#f26c34", hoverColor:"#f26c34"},
  "1110":{mainColor:"#08312a", hoverColor:"#08312a"},
  "1115":{mainColor:"#4F2977", hoverColor:"#4F2977"},
  "1257":{mainColor:"#183630", hoverColor:"#183630"},
  "1286":{mainColor:"#0cb1ef", hoverColor:"#0cb1ef"},
  "1287":{mainColor:"#325e89", hoverColor:"#325e89"},
  "1289":{mainColor:"#0080c0",hoverColor:"#0080c0"},
  "1300":{mainColor:"#648093", hoverColor:"#648093"},
  "1305":{mainColor:"#3cc2f0",hoverColor:"#3cc2f0"},
  "1306":{mainColor:"#163057",hoverColor:"#163057", logoStyle:"width: 130px;height: 90px;background-position: 100%;"},
  "1308":{mainColor:"#000000",hoverColor:"#666666", logoStyle:"position: relative;left: 72px;"},
  "1309":{mainColor:"#006491",hoverColor:"#006491"},
  "1310":{mainColor:"#1e40be",hoverColor:"#1e40be"},
  "1311":{mainColor:"#0069aa",hoverColor:"#0069aa"},
  "1314":{mainColor:"#328734",hoverColor:"#328734"},
  "1315":{mainColor:"#058348",hoverColor:"#058348"},
  "1317":{mainColor:"#0091b2",hoverColor:"#0091b2", logoStyle:"position:relative;left:43px"},
  "1324":{mainColor:"#0783FF",hoverColor:"#0783FF"},
  "1326":{mainColor:"#472683",hoverColor:"#472683"},
  "0751":{mainColor:"#d52b1e",hoverColor:"#af261b"},
  "0956":{mainColor:"#10384f",hoverColor:"#10384f", logoStyle:" width: 300px;height: 90px;background-position: 1200%;"},
  "1275":{mainColor:"#007B96",hoverColor:"#007B96", logoStyle:" width: 220px;height: 90px;background-position: 100%;"},
  "1254":{mainColor:"#002060",hoverColor:"#002060", logoStyle:" width: 220px;height: 90px;background-position: 100%;"},
};
